import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        fontWeight: '700',
        fontSize: '2rem',
        paddingTop: '15rem',
        letterSpacing: '1px',
      }}
    >
      <div>404 | Not Found</div>
      <Link to='/'>
        <Button type='primary' shape='round' ghost>
          Home Page
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
